@if (hasActions()) {
  <div class="ai-suggest-actions">
    @if (title()) {
      <div class="ai-suggest-actions__title">{{ title() }}</div>
    }
    <div class="ai-suggest-actions__list">
      @for (action of actions(); track $index) {
        <button type="button" class="ai-suggest-actions__card" (click)="actionClicked.emit(action)">
          <div class="ai-suggest-actions__icon">
            <mat-icon>{{ actionIcon(action) }}</mat-icon>
          </div>
          <div class="ai-suggest-actions__content">
            <div class="ai-suggest-actions__label">{{ action.label }}</div>
            <div class="ai-suggest-actions__description">{{ action.description }}</div>
          </div>
        </button>
      }
    </div>
  </div>
}
